module.exports = __webpack_public_path__ + "img/quanbuwanglai.d549c970.png";